import EditButton from './component';

export default EditButton;
